import React, { useState } from 'react';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../firebase';
import 'bootstrap/dist/css/bootstrap.min.css';

const EnrollFormPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    studentYear: '',
    department: '',
    course: '',
    subject: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, "enrollments"), formData);
      alert('Enrollment submitted successfully!');
      setFormData({
        name: '',
        mobile: '',
        email: '',
        studentYear: '',
        department: '',
        course: '',
        subject: ''
      });
    } catch (error) {
      console.error("Error submitting enrollment: ", error);
      alert('Failed to submit enrollment!');
    }
  };

  return (
    <div className="container py-5 my-5 col-lg-9">
      <h2 className="mb-4 display-5 fw-bold text-info text-center">Registration/Enroll Form</h2> <hr/>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="name" className="form-label">Name</label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="mobile" className="form-label">Mobile</label>
              <input
                type="text"
                className="form-control"
                id="mobile"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
              
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="studentYear" className="form-label">Student Year</label>
              <select
                className="form-select"
                id="studentYear"
                name="studentYear"
                value={formData.studentYear}
                onChange={handleChange}
                required
              >
                <option value="">Choose Year</option>
                <option value="1st Year">1st Year</option>
                <option value="2nd Year">2nd Year</option>
                <option value="3rd Year">3rd Year</option>
                <option value="4th Year">4th Year</option>
                <option value="other">Integrated Program</option>
              </select>
            </div>
          </div>

          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="department" className="form-label">Department</label>
              <select
                className="form-select"
                id="department"
                name="department"
                value={formData.department}
                onChange={handleChange}
                required
              >
                <option value="">Choose Department</option>
                <option value="CSE">CSE </option>
                <option value="ECE">ECE </option>
                <option value="EEE">EEE </option>
                <option value="ME">ME</option>
                <option value="Civil">Civil</option>
                <option value="Bcom">B.Com</option>
                <option value="bsc">BSc (Under Graduate)</option>
                <option value="Msc">MSc (Post Graduate)</option>
                <option value="bba">BBA</option>
                <option value="bbm">BBM</option>
                <option value="mba">MBA</option>
                <option value="Others">Other Department Not Specified</option>
               
              </select>

            </div>
            <div className="mb-3">
              <label htmlFor="course" className="form-label">Course</label>
              <select
                className="form-select"
                id="course"
                name="course"
                value={formData.course}
                onChange={handleChange}
                required
              >
                <option value="">Choose Course</option>
                <option value="Quantum Computing">Quantum Computing program</option>
                <option value="Full Stack Development">Full Stack AI Development Course</option>
                <option value="ai_program">Ai - Agents & LLM Developer</option>
                <option value="Mobile App Development">Mobile Apps Development (Android & IOS)</option>
                <option value="Cloud Computing">Cloud Computing (Aws, GCP, Azure, other cloud Platforms) </option>
                <option value="DevOps">DevOps Engineer</option>
                <option value="AI-ML">AI & ML Engineer</option>
                <option value="Robotics">Robotics Engineer</option>
                <option value="cyber">Cyber Security Engineer</option>
                <option value="devops">DevSecOps Engineer</option>
                <option value="Data_sci">Data Science Program</option>
                <option value="data -ana">Data Analyst</option>
                <option value="business">Business Analyst & PMP Course</option>
                <option value="geology">Geo Technical Program</option>
                <option value="geology">Geo Scientist course ( IIT-JAM , GATE)</option>
                <option value="environment">Environmental Data & Technical Program </option>
              </select>
              <p className='text-secondary' style={{fontSize:'0.8rem'}} ><strong>Note:- </strong >Select Course/Training for Job Oriented , IIT-JAM, GATE and Other Entrance exams, <small className=' text-danger fw-bold' ><b> (Exclude Abroad Exams)</b></small> We Recommend long term for 6 Months,1 Year/2year sessions for Better performance in STEM Education Systems </p>

            </div>
            <div className="mb-3">
              <label htmlFor="subject" className="form-label">Subject</label>
              <input
              placeholder=' Enter Your Subject / Academic background'
                type="text"
                className="form-control"
                id="subject"
                name="email"
                onChange={handleChange}
                required
                value={formData.subject}
              />
            </div>

          
          </div>
        </div>
        <div className="text-center">
          <button type="submit" className="btn bg-dark text-light my-3">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default EnrollFormPage;
